import React, { Suspense } from "react";
import { Toaster } from "react-hot-toast";
import { Toaster as Sonner } from "./components/ui/sonner";
import { MemoryRouter as Router, Routes, Route } from "react-router-dom";

import { Onboarding } from "./pages/onboarding";
import { Home } from "./pages/home";
import { Analysis } from "./pages/analysis";
import { Processed } from "./pages/processed";
import { KeyTermMitigations } from "./pages/keyterm-mitigations";
import { KeyTermProcessed } from "./pages/keyterm-processed";
import { SettingsPage } from "./pages/settings";
import { Login } from "./pages/login";
import { Signup } from "./pages/signup";
import { ForgotPassword } from "./pages/forgot-pwd";
import { ManagePlaybook } from "./pages/manage-playbook";
import { UploadPlaybook } from "./components/upload";
import { AppLayout, DefaultLayout } from "./components/app-layout";
import { Loader } from "./components/loader";

const ContactUs = React.lazy(() => import("./pages/ContactUs/ContactUs"));

const App: React.FC = () => {
	return (
		<div className="h-screen w-screen">
			<Toaster position="top-center" reverseOrder={false} />
			<Sonner closeButton position="top-right" />
			<Router>
				<Suspense fallback={<Loader />}>
					<Routes>
						<Route element={<DefaultLayout />}>
							<Route path="/login" element={<Login />} />
							<Route path="/onboarding" element={<Onboarding />} />
							<Route path="/signup" element={<Signup />} />
							<Route path="/reset-pwd" element={<ForgotPassword />} />
						</Route>

						<Route element={<AppLayout />}>
							<Route path="/" element={<Home />} />
							<Route path="/analyze" element={<Analysis />} />
							<Route path="/analyze/:type/:keyTermIdx" element={<KeyTermMitigations />} />
							<Route path="/processed" element={<Processed />} />
							<Route path="/processed/:keyTermIdx" element={<KeyTermProcessed />} />
							<Route path="/manage-playbook" element={<ManagePlaybook />} />
							<Route path="/settings" element={<SettingsPage />} />
							<Route path="/upload" element={<UploadPlaybook />} />
							<Route path="/info" element={<ContactUs />} />
						</Route>
					</Routes>
				</Suspense>
			</Router>
		</div>
	);
};

export default App;
